import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'store/store';

const selector = (state: RootState) => state.dataProcessingGroupByStatus;

const dataProcessingGroupByStatusData = createSelector([selector], (state) => state);

export default {
  dataProcessingGroupByStatusData
};
